import React from "react";
import { defineMessages, injectIntl } from 'react-intl';
import { IconClose, IconPin } from "../icons/svg";
import Helpers from "../lib/helpers";
import { MESSAGE_ACTION_PIN, NODE_SUBTYPE_MESSAGE } from "../tinode/constants";
import { copyTextToClipboard } from '../lib/utils.js'

const messages = defineMessages({
  copy_success: {
    id: 'copy_success',
    defaultMessage: 'Copied successfully',
    description: 'Copied successfully'
  }
})


class Pin extends React.Component {
  constructor(props) {
    super(props);

    this.handleUnPin = this.handleUnPin.bind(this);
    this.handleAlert = this.handleAlert.bind(this);
    this.handleQuoteClick = this.handleQuoteClick.bind(this);
  }

  handleAlert() {
    const messages = defineMessages({
      alert_unpin_title: {
        id: 'alert_unpin_title',
        defaultMessage: 'Confirm',
        description: 'Confirm'
      },
      alert_unpin_message: {
        id: 'alert_unpin_message',
        defaultMessage: 'Unpin this message?',
        description: 'Unpin this message?'
      },
    });
    const { formatMessage } = this.props.intl;
    this.props.onShowAlert(
      formatMessage(messages.alert_unpin_title), // title
      formatMessage(messages.alert_unpin_message),
      (_ => { this.handleUnPin(); }), // onConfirm
      null, // "OK"
      true, // Show Reject button
      null  // "Cancel"
    );
  }

  handleUnPin() {
    const { topic, tinode } = this.props;
    const { pinMessage } = topic;
    tinode.sendPin(pinMessage, MESSAGE_ACTION_PIN.UNPIN);
  }

  handleQuoteClick() {
    const { formatMessage } = this.props.intl;
    const { topic } = this.props;
    const { pinMessage } = topic;
    // if (pinMessage.seq) {
    //    this.props.handleQuoteClick(pinMessage, pinMessage.seq);
    // } else {
    //    const { formatMessage } = this.props.intl;
    //    Helpers.showWarningToasts(formatMessage({
    //       id: "toast_warning_not_mes_pin",
    //       defaultMessage: "The message does not exist or has been deleted"
    //    }))
    // }

    copyTextToClipboard(pinMessage.content)
    Helpers.showSuccessToasts(formatMessage(messages.copy_success));
  }

  render() {
    const { topic, tinode } = this.props;
    const { pinMessage } = topic;
    if (pinMessage && pinMessage.from && pinMessage.content) {
      const topicInfo = tinode.getTopicByName(pinMessage.from, {
        isCreateWhenNotExist: true,
      });
      const name = topicInfo.getTopicName();
      const content = pinMessage.content;
      let context = typeof content === 'string'
        ? content
        : typeof content?.replyBody === 'string'
          ? content.replyBody
          : typeof content?.txt === 'string'
            ? content.txt
            : '';
      const hasTags = (Array.isArray(pinMessage.tags) && pinMessage.tags.length > 0)
        || (Array.isArray(content?.tags) && content.tags.length > 0);
      if (hasTags) {
        context = Helpers.getContentTags(pinMessage, tinode);
      } else if (pinMessage.subtype === NODE_SUBTYPE_MESSAGE.RECALL) {
        const { formatMessage } = this.props.intl;
        context = formatMessage({
          id: 'message_recall',
          defaultMessage: 'message has been withdrawn',
          description: 'message has been withdrawn'
        });
      }
      return (
        <div className="message-pin">
          <div className="close" onClick={this.handleAlert}>
            <IconClose />
          </div>
          <div className="left">
            <IconPin />
          </div>
          <div className="right">
            <div className="title">{name}</div>
            <div className="desc" onClick={this.handleQuoteClick}>{context}</div>
          </div>
        </div>
      )
    }
    return null;
  }
}

export default injectIntl(Pin);
